import {
  Box,
  Container,
  Header,
  ColumnLayout
} from '@cloudscape-design/components'
import { FC } from 'react'

interface ValueWithLabelProps {
  label: string
  value: string
  version: string[]
}

interface SslCertProps {
  sslCert: Record<any, any>
}

const ValueWithLabel: FC<ValueWithLabelProps> = ({ label, value }) => {
  return (
    <div>
      <Box variant="awsui-key-label">{label}</Box>
      <div>{value}</div>
    </div>
  )
}

const RenderSslCertFields: FC<SslCertProps> = ({ sslCert: project }) => {
  return (
    <>
      <Container>
        <Header variant="h3">Request Details</Header>
        <ColumnLayout columns={3} variant="text-grid">
          {project.map((element: ValueWithLabelProps, index: number) => {
            return <ValueWithLabel {...element} key={element.label + index} />
          })}
        </ColumnLayout>
      </Container>
    </>
  )
}

export default RenderSslCertFields
